import React from 'react';
import { EditableInfoComponent, Row } from 'components';
import { RatesAddEditModal } from './addEdit';
import { DeleteModal } from './delete';
import { ShippingMethodType } from 'typings/client';
import { ShippingRateCard } from './shippingRateCard';
import styles from './styles.module.scss';
import { useSpecialRates } from './useSpecialRates';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';
import { PricingRuleIcon } from 'components/common/icons';

export interface Price {
  metrics: 'KG' | 'VOLUME';
  measurementRange: string;
  price: string;
}

export interface SpecialRate {
  id?: string;
  countryId: string;
  warehouseId: string;
  warehouse: Record<string, any>;
  city: string;
  shippingMethods: ShippingMethodType[] | [];
  prices: Price[];
}

export const ShippingRates = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const {
    openModal,
    dataToEdit,
    specialRates,
    isDeleteModalOpen,
    onHandleEdit,
    onHandleDelete,
    onDeleteModalClose,
    onModalStateChange,
  } = useSpecialRates();
  return (
    <>
      <Row className={styles.shipping_special_rate}>
        <EditableInfoComponent
          title={'Country Shipping Rates'}
          icon={<PricingRuleIcon />}
          creatable={hasAccess(PERMISSIONS.countries.shipping_rate.write)}
          editable={false}
          onAdd={onModalStateChange}
        />
        {specialRates.map((data: SpecialRate) => (
          <ShippingRateCard
            key={data.id}
            specialRate={data}
            onHandleEdit={onHandleEdit}
            onHandleDelete={onHandleDelete}
          />
        ))}
      </Row>
      <RatesAddEditModal modalState={openModal} onModalStateChange={onModalStateChange} dataToEdit={dataToEdit} />
      <DeleteModal openModal={isDeleteModalOpen} onDeleteModalClose={onDeleteModalClose} dataToDelete={dataToEdit} />
    </>
  );
});
